import { Injectable } from '@angular/core';
import { Column, Upright } from '../asset/asset.dto';

@Injectable()
export abstract class UprightService {
  abstract get(division: string, id: string): Promise<Upright>;
  abstract list(division: string, systemId: string): Promise<Upright[]>;
  abstract listColumns(division: string, assetIds: string[], rowInx?: number): Promise<Column[]>;
}
